<template>
  <el-dialog :title="title" :visible.sync="dialogVisible" width="800px" @close="handleClose">
    <el-tabs v-model="activeName" @tab-click="handleTabClick">
      <el-tab-pane label="铺货价格（通用）" name="common"></el-tab-pane>
      <el-tab-pane label="铺货价格（店铺）" name="shops"></el-tab-pane>
    </el-tabs>
    <div v-if="activeName === 'shops' && !shopList.length" style="color: red">
      暂无店铺价格策略，如店铺需配置独立铺货价格策略， 可前往 <el-link @click="toPlatformConf"> {{ platformPriceNames.name }}铺货配置</el-link> 配置
    </div>
    <div v-else>
      <div v-if="activeName === 'shops'">
        店铺名称：
        <el-select v-model="shopId" placeholder="请选择" width="200px" @change="changeShop">
          <el-option v-for="item in shopList" :key="item.id" :label="item.shortTitle || item.title" :value="item.id"> </el-option>
        </el-select>
        <el-divider></el-divider>
      </div>
      <div class="price-rules">
        <el-row :gutter="10">
          <el-col :span="4"><div class="label">价格配置：</div></el-col>
          <el-col :span="16"
            ><div class="content">{{ priceRule.priceConfText }}</div></el-col
          >
        </el-row>
        <el-row :gutter="10">
          <el-col :span="4"><div class="label">铺货价格递增：</div></el-col>
          <el-col :span="6"
            ><div class="content">{{ priceRule.incr ? '是' : '否' }}</div></el-col
          >
          <template v-if="priceRule.incr">
            <el-col :span="4"><div class="label">递增金额：</div></el-col>
            <el-col :span="6"
              ><div class="content">{{ priceRule.incr }}</div></el-col
            >
          </template>
        </el-row>
        <el-row :gutter="10" v-if="isDistributor && priceRule.supplyFreight">
          <el-col :span="4"><div class="label">附加供销运费：</div></el-col>
          <el-col :span="16">
            <div class="content">{{priceRule.supplyFreight}}</div>
          </el-col>
        </el-row>
        <div v-if="priceRule.incr" style="color: red">
        配置铺货价格递增后可能会发生破价，导致商品发布失败，具体以平台后台信息及铺货日志为准
      </div>
      </div>
      <div class="price-list">
        <el-table height="300px" :data="tableData">
          <template v-for="col in cols">
            <el-table-column v-if="col.prop === 'price'" :key="col.prop" :prop="col.prop" :label="col.label" align="center">
              <template slot-scope="{ row }">
                <span :class="{ dangerText: row.isDanger }"> {{ row.price }}</span>
              </template>
            </el-table-column>
            <el-table-column v-else :key="col.prop" :prop="col.prop" :label="col.label" align="center"></el-table-column>
          </template>
        </el-table>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { mapGetters } from "vuex"
import { preViewSalePrice } from '@/servers/prod/center/index.js';
import { getDistributionConfig } from '@servers/prod/conf/index.js';
import { getPriceName } from '@/dictionary/price';

export default {
  components: {},
  props: {},
  data() {
    return {
      title: '铺货销售价预览',
      dialogVisible: false,
      opts: {},
      activeName: 'common',
      shopId: '',
      shopList: [],
      cols: [],
      tableData: [],
      priceRule: {},
      platform: '',
      getPriceName,
      platformPriceNames: {},
    };
  },
  computed: {
      ...mapGetters(['isDistributor']),
  },
  methods: {
    // 获取配置价格的展示方式
    getPriceTypeName(type) {
      const priceMap = new Map([
        ['now', this.platformPriceNames.name + this.platformPriceNames[this.opts.type]],
        ['pdd_multi_price', '拼多多拼单价'],
        ['base_sales', '基础资料销售价'],
        ['base_market', '基础资料市场价'],
        ['base_purchase', '基础资料成本价'],
        ['base_base_selling', '基础资料基本售价'],
      ]);
      return priceMap.get(type) || '基础资料销售价';
    },
    openDialog(opts = {}) {
      this.opts = opts;
      let priceName = opts.priceName || '销售价';
      this.dialogVisible = true;
      this.platform = opts.platform;
      this.platformPriceNames = this.getPriceName(this.platform);
      this.title = `铺货${priceName}预览`;
      this.getPriceData();
      this.getConfig();
    },
    getControlPriceText(item) {
      if (item.minControlPrice && item.maxControlPrice) {
        return `${item.minControlPrice}元 ~ ${item.maxControlPrice}元`;
      } else if (item.minControlPrice && !item.maxControlPrice) {
        return `不低于${item.minControlPrice} 元`;
      } else if (!item.minControlPrice && item.maxControlPrice) {
        return `不高于${item.maxControlPrice}元`;
      } else {
        return '—';
      }
    },
    checkPrice(item) {
      if(!this.opts.isDistribution) return false
      const { minControlPrice, maxControlPrice, price } = item;
      if (!price) return false;
      // 价格低于最低控制价
      if (minControlPrice && price < minControlPrice) return true;
      // 价格高于最高控制价
      if (maxControlPrice && price > maxControlPrice) return true;

      return false;
    },

    handleClose() {
      Object.assign(this.$data, this.$options.data());
    },
    toPlatformConf() {
      const isDistributor = this.$store.getters.userInfo.loginIdentity == '2';
      const routeData = this.$router.resolve({
        path: isDistributor ? '/distributor/prod_conf' : '/supplier/prod_conf',
        query: { tabName: 'distribution',platform: this.platform, platformName: this.platformPriceNames.name},
      });
       window.open(routeData.href, '_blank', 'noopener,noreferrer')
    },
    handleTabClick() {
      this.shopId = '';
      if (this.activeName === 'shops') {
        if (this.shopList.length) {
          this.shopId = this.shopList[0].id;
          this.getPriceData();
        }
      } else {
        this.getPriceData();
      }
    },
    changeShop() {
      this.getPriceData();
    },
    async getPriceData() {
      const { opts, shopId } = this;
      const { skuNames = [], priceName = '销售价', requestParams } = opts;
      
      // 请求数据
      const params = { ...requestParams, shopId,isDistribution:+this.isDistributor };
      const { skuData = [], price } = await preViewSalePrice(params) || {};
      
      // 处理表格数据
      const tableData = skuData.map(sku => {
        const specValues = sku.specDetailName ? sku.specDetailName.split(',') : [];
        const rowData = skuNames.reduce((acc, name, idx) => {
          acc[name] = specValues[idx] || '';
          return acc;
        }, {});
        
        return {
          ...rowData,
          price: sku.price || 0,
          controlPrice: this.getControlPriceText(sku),
          isDanger: this.checkPrice(sku),
          freightPrice:sku.freightPrice
        };
      });

      // 处理价格规则
      this.getPriceRule(price)
      let _priceName = priceName;
      let isShowSupplyFreight = this.isDistributor && this.priceRule.supplyFreight
      if(isShowSupplyFreight){
        _priceName += '(含附加供销运费)'
      }
      const cols = [
        ...skuNames.map(name => ({ prop: name, label: name })),
        this.opts.isDistribution ? { prop: 'controlPrice', label: '分销控价（元）' } : null,
        isShowSupplyFreight ? { prop: 'freightPrice', label: '附加供销运费' } : null,
        { prop: 'price', label: _priceName }
      ];
      this.cols = cols.filter(Boolean);
      this.tableData = tableData;
    },
    getPriceRule(price) {
      const priceRules = price ? JSON.parse(price) : [];
      this.priceRule = priceRules.find(item => item.type === this.opts.type) || {};
      
      const { formulaValue = {}, way,supplyFormulaValue={},isCalculateFreight } = this.priceRule;
      let priceConfText = `取${this.platformPriceNames.name}资料保存的${this.platformPriceNames[this.opts.type]}`;
      if(!!this.opts?.isDistribution && !!isCalculateFreight){
        this.priceRule.supplyFreight = `供销运费 X ${supplyFormulaValue.percentage}% + ${supplyFormulaValue.addValue}元 - ${supplyFormulaValue.subtractionValue}元`
      }
      if (way === 'formula') {
        const { 
          percentage = 0, 
          addValue = 0, 
          subtractionValue = 0, 
          priceMultiplier 
        } = formulaValue;
        priceConfText = `${this.getPriceTypeName(priceMultiplier)} X ${percentage}% + ${addValue}元 - ${subtractionValue}元`;
      }
      // 更新组件数据
      this.priceRule.priceConfText = priceConfText;
    },
    async getConfig() {
      const res = await getDistributionConfig({ shopType: this.opts.requestParams.shopType });
      const shopPriceConfList = res.shopPriceConfList || [];
      const allPlatformShops = this.$store.getters.get_AllShops_BySource(this.platform);
      if(this.platform === 'fxg') {
        const fxgGxPlatformShops = this.$store.getters.get_AllShops_BySource('fxg_gx');
        allPlatformShops.push(...fxgGxPlatformShops)
      }
      const shopList = [];
      shopPriceConfList.forEach(item => {
        (item.shopIds || []).forEach(shopId => {
          const findItem = allPlatformShops.find(shop => shop.id === shopId);
          if (!shopList.some(shop => shop.id == shopId) && findItem) {
            shopList.push(findItem);
          }
        });
      });
      this.shopList = shopList;
    },
  },
  mounted() {},
};
</script>

<style lang="scss" scoped>
.price-rules {
  font-size: 12px;
  .el-row {
    margin-bottom: 10px;
  }
  .label {
    text-align: right;
  }
  .content {
    font-weight: 700;
  }
}
.price-list {
  .dangerText {
    color: red;
  }
}
</style>
